import {
    dateFormat, formsSync,
    isValidEmail, processMobileFile,
    renderBEerrors,
    renderFEerrors,
    showSnackbar,
    toggleInactiveElements, truncateCoords,
    validatePassword
} from "./Utils.js";
import Data from "./Data.js";

export default class Actions {

    constructor() {
        this.data = new Data();
    }

    submitFeedback(target) {
        const form = document.getElementById('feedback__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.feedback.trim().length) {
            errors.feedback = __('help.error_enter_your_feedback');
        }

        if (!Object.keys(errors).length) {
            form.querySelector('button').classList.add('button--disabled');
            const data = new Data();
            data.submitFeedback(formData.feedback).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('help.text_feedback_submitted_successful'), 'success');
                    form.querySelector('textarea#feedback').value = '';
                    form.querySelectorAll('label .maxlength').forEach(item => item.remove());
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    submitSupport(target) {
        const form = document.getElementById('contact_support__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.subject.trim().length || formData.subject.trim().length < 5) {
            errors.subject = __('help.error_enter_your_subject');
        }

        if (!formData.description.trim().length || formData.description.trim().length < 20) {
            errors.description = __('help.error_enter_your_description');
        }

        if (!Object.keys(errors).length) {
            form.querySelector('button').classList.add('button--disabled');

            const data = new Data();
            data.submitContactSupport(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('help.text_contact_support_submitted_successful'), 'success');

                    form.querySelectorAll('.dropdown__content').forEach(item => {
                        item.querySelector('.dropdown__item').click();
                    });

                    form.querySelector('.dropdown--active')?.classList.remove('dropdown--active');
                    form.querySelector('textarea#subject').value = '';
                    form.querySelector('textarea#description').value = '';
                    form.querySelectorAll('label .maxlength').forEach(item => item.remove());
                    form.querySelector('button').classList.add('button--disabled');
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    setNewPassword()
    {
        const form = document.getElementById('change_password__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.new_password.trim().length) {
            errors.new_password = __('error_enter_your_new_password');
        }

        if (!formData.new_password_again.trim().length) {
            errors.new_password_again = __('error_enter_your_new_password_again');
        }

        if (formData.new_password.trim().length && formData.new_password_again.trim().length && formData.new_password !== formData.new_password_again) {
            errors.new_password = __('error_new_password_should_match_new_password_again');
            errors.new_password_again = __('error_new_password_again_should_match_new_password');
        }

        if (!Object.keys(errors).length) {
            if (!validatePassword(formData.new_password.trim())) {
                errors.new_password = __('error_password_validation');
            }
        }

        if (!Object.keys(errors).length) {
            const data = new Data();
            data.setNewPassword(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar('text_saved_successful', 'success', '/' + SYSTEM_LANGUAGE + '/overview/dashboard', true);
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    sendResetLink()
    {
        const form = document.getElementById('forgot_password__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.email.length) {
            errors.email = __('error_enter_email_address');
        }

        if (formData.email.length && !isValidEmail(formData.email)) {
            errors.email = __('error_enter_valid_email_address');
        }

        if (!Object.keys(errors).length) {
            const data = new Data();
            data.passwordResetLink(formData.email).then((response) => {
                if (response.status === 'success' && !response.error) {
                    form.querySelector('.form__group--message strong').textContent = formData.email;
                    form.querySelector('#reset-password-view').classList.remove('form__view--active');
                    form.querySelector('#reset-password-success').classList.add('form__view--active');
                }  else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    resendVerificationEmail(target)
    {
        const payload = {user_id: target.dataset.id, token: target.dataset.token, type: target.dataset.type};
        const data = new Data();
        data.resendVerificationEmail(payload).then((response) => {
            target.classList.add('button--disabled');

            if (response.status === 'success' && !response.error) {
                showSnackbar(__('text_resend_verification_email_sent'), 'success');
            }
        });
    }

    signIn() {
        const form = document.getElementById('sign_in__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.email.length) {
            errors.email = __('error_enter_email_address');
        }

        if (!formData.password.length) {
            errors.password = __('error_enter_password');
        }

        if (formData.email.length && !isValidEmail(formData.email)) {
            errors.email = __('error_enter_valid_email_address');
        }

        if (!Object.keys(errors).length) {
            const data = new Data();
            data.signIn(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    window.location.href = '/' + SYSTEM_LANGUAGE + '/overview/dashboard';
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }
    
    demoSignIn() {
        const data = new Data();
        data.demoSignIn({locale: SYSTEM_LANGUAGE}).then((response) => {
            if (response.status === 'success' && !response.error) {
                window.location.href = '/' + SYSTEM_LANGUAGE + '/overview/dashboard';
            }
        });
    }

    signUp() {
        const form = document.getElementById('sign_up__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = [];

        if (!formData.display_name.length) {
            errors.display_name = __('error_enter_display_name');
        }

        if (!/^[\p{L}\p{N}_\-\s]+$/u.test(formData.display_name)) {
            errors.display_name = __('error_display_name_invalid');
        }

        if (!formData.email.length) {
            errors.email = __('error_enter_email_address');
        }

        if (!formData.password.length) {
            errors.password = __('error_enter_password');
        }

        if (formData.email.length && !isValidEmail(formData.email)) {
            errors.email = __('error_enter_valid_email_address');
        }

        if (!Object.keys(errors).length) {
            if (!validatePassword(formData.password.trim())) {
                errors.password = __('error_password_validation');
            }
        }

        if (!Object.keys(errors).length) {
            const data = new Data();
            formData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            formData.language = SYSTEM_LANGUAGE;

            data.signUp(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    window.location.href = '/' + SYSTEM_LANGUAGE + '/overview/dashboard';
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    editSpace() {
        const form = document.getElementById('new_space__form');
        const formData = Object.fromEntries(new FormData(form));

        let errors = {};

        if (formData.name.trim().length <= 0) {
            errors.name = __('error_enter_space_name');
        }

        if (formData.incomes.trim().length <= 0 && formData.expenses.trim().length <= 0) {
            errors.incomes = __('error_select_at_least_one_category');
            errors.expenses = __('error_select_at_least_one_category');
        }

        formData.members = [...form.querySelectorAll('.chip')].map(email => email.textContent.trim()).join(',');

        if (!Object.keys(errors).length) {
            this.data.newSpace(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    window.location.href = '/' + SYSTEM_LANGUAGE + '/spaces';
                    return;
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    changePassword() {
        const form = document.getElementById('account_security_change_password__form');
        let formData = new FormData(form);
        formData = Object.fromEntries(formData);

        let errors = [];

        if (!formData.current_password.trim().length) {
            errors.current_password = __('error_enter_your_password');
        }

        if (!formData.new_password.trim().length) {
            errors.new_password = __('error_enter_your_new_password');
        }

        if (!formData.new_password_again.trim().length) {
            errors.new_password_again = __('error_enter_your_new_password_again');
        }

        if (formData.new_password.trim().length && formData.new_password_again.trim().length && formData.new_password !== formData.new_password_again) {
            errors.new_password = __('error_new_password_should_match_new_password_again');
            errors.new_password_again = __('error_new_password_again_should_match_new_password');
        }

        if (!Object.keys(errors).length) {

            if (!validatePassword(formData.new_password.trim())) {
                errors.new_password = __('error_password_validation');
            }
        }

        if (!Object.keys(errors).length) {
            this.data.changePassword(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('text_saved_successful'), 'success');
                    form.querySelector('.button--success').classList.add('button--disabled');
                    form.querySelectorAll('input').forEach(i => i.value = '');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    updateAccountSettings() {
        const form = document.getElementById('account_settings__form');
        let formData = new FormData(form);
        formData.delete('search');

        formData = Object.fromEntries(formData);

        let errors = [];

        if (!formData.display_name.trim().length) {
            errors.display_name = __('error_enter_display_name');
        }

        if (!/^[\p{L}\p{N}_\-\s]+$/u.test(formData.display_name)) {
            errors.display_name = __('error_display_name_invalid');
        }

        if (!Object.keys(errors).length) {
            formData.display_name = formData.display_name.trim();
            form.querySelector('.button--success').classList.add('button--disabled');
            this.data.updateAccountSettings(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    document.querySelector('.user .dropdown__selected .text').textContent = formData.display_name;
                    document.querySelector('.user .dropdown .display-name').textContent = __('text_hey') + ' ' + formData.display_name + '!';
                    form.querySelector('input#display_name').value = formData.display_name;
                    showSnackbar(__('text_saved_successful'), 'success');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    transactionTemplateSave() {
        const form = document.getElementById('transaction_template__form');
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (!formData.get('name')) {
            errors.name = __('error_provide_name');
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            form.querySelector('.button--success').classList.add('button--disabled');

            this.data.transactionTemplateSave(formData).then((response) => {
                if (response.status === 'success' && !response.error) {

                    form.querySelector('#name').value = '';

                    const categoryDropdown = form.querySelector('.category .dropdown');
                    categoryDropdown.querySelector('.dropdown__selected span').textContent = __('label_choose_category');
                    categoryDropdown.querySelector('.dropdown__selected').dataset.value = '';
                    categoryDropdown.querySelector('#category').value = '';

                    form.querySelector('#amount').value = '';
                    form.querySelector('#comment').value = '';

                    showSnackbar(__('transaction_templates.text_created_successful'), 'success');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    transactionSave() {
        const form = document.getElementById('transaction__form');
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (!/\d{4}\-\d{2}\-\d{2}\s\d{2}:\d{2}/.test(formData.get('created_at'))) {
            errors.created_at = __('error_choose_date_and_time');
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            formData.latitude = truncateCoords(formData.latitude);
            formData.longitude = truncateCoords(formData.longitude);
            form.querySelector('.button--success').classList.add('button--disabled');

            this.data.transactionSave(formData).then((response) => {
                if (response.status === 'success' && !response.error) {

                    const templateDropdown = form.querySelector('.template .dropdown');

                    if (templateDropdown) {
                        templateDropdown.querySelector('.dropdown__selected span').textContent = __('label_choose_template');
                        templateDropdown.querySelector('.dropdown__selected').dataset.value = '';
                        templateDropdown.querySelector('#template').value = '';
                    }

                    const categoryDropdown = form.querySelector('.category .dropdown');
                    categoryDropdown.querySelector('.dropdown__selected span').textContent = __('label_choose_category');
                    categoryDropdown.querySelector('.dropdown__selected').dataset.value = '';
                    categoryDropdown.querySelector('#category').value = '';

                    form.querySelector('#amount').value = '';
                    form.querySelector('#comment').value = '';

                    showSnackbar(__('transactions.text_created_successful'), 'success');
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    transactionTemplateEdit() {
        const form = document.getElementById('transaction_template__form');
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (!formData.get('name')) {
            errors.name = __('error_provide_name');
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            form.querySelector('.button--success').classList.add('button--disabled');
            this.data.transactionTemplateUpdate(formData.transaction_template_id, formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('transaction_templates.text_updated_successful'), 'success');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    async scanner() {
        const form = document.getElementById('scanner__form');
        let formData = new FormData(form);
        let payload = new FormData();

        const galleryFiles = formData.getAll('gallery');
        const cameraFiles = formData.getAll('camera');

        const allFiles = [...cameraFiles, ...galleryFiles].filter(file => file.size > 0);

        if (allFiles.length) {
            const processedFiles = await Promise.all(
                allFiles.map(file => processMobileFile(file))
            );

            for (const file of processedFiles) {
                payload.append('file[]', file);
            }
        }

        this.data.scanner(payload).then((response) => {
            if (response.status === 'success' && !response.error) {

            } else {

            }
        });
    }

    transactionEdit() {
        const form = document.getElementById('transaction__form');
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (!/\d{4}\-\d{2}\-\d{2}\s\d{2}:\d{2}/.test(formData.get('created_at'))) {
            errors.created_at = __('error_choose_date_and_time');
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            form.querySelector('.button--success').classList.add('button--disabled');

            this.data.transactionUpdate(formData.transaction_id, formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('text_saved_successful'), 'success');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    scheduledTransactionSave() {
        const form = document.getElementById('scheduled_transaction__form');
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (formData.get('frequency_type') === 'once') {
            if (!/\d{4}\-\d{2}\-\d{2}\s\d{2}:\d{2}/.test(formData.get('when'))) {
                errors.when = __('scheduled_transactions.error_when');
            } else {
                const selected = new Date(formData.get('when'));
                const now = new Date();

                if (selected < now) {
                    errors.when = __('scheduled_transactions.error_when_cannot_be_in_the_past');
                }
            }
        }

        if (formData.get('frequency_type') === 'weekly') {
            let day = Number(formData.get('due_day'));
            if (day <= 0 || day > 7) {
                errors.due_day = __('scheduled_transactions.error_choose_day');
            }
        }

        if (formData.get('frequency_type') === 'monthly') {
            if (formData.get('end_of_month') === null) {
                let day = Number(formData.get('due_day'));
                if (day <= 0 || day > 31) {
                    errors.due_day = __('scheduled_transactions.error_choose_day');
                }
            }
        }

        if (formData.get('frequency_type') === 'yearly') {
            let day = Number(formData.get('frequency_interval'));
            if (day <= 0 || day > 12) {
                errors.frequency_interval = __('scheduled_transactions.error_choose_month');
            }

            if (formData.get('end_of_month') === null) {
                let day = Number(formData.get('due_day'));
                if (day <= 0 || day > 31) {
                    errors.due_day = __('scheduled_transactions.error_choose_day');
                }
            }
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            form.querySelector('.button--success').classList.add('button--disabled');

            this.data.scheduledTransactionSave(formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('scheduled_transactions.text_created_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/scheduled-transactions');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    scheduledTransactionEdit() {
        const form = document.getElementById('scheduled_transaction__form');
        const id = form.closest('.section').dataset.id;
        let formData = new FormData(form);
        formData.delete('search');

        let errors = {};

        if (formData.get('frequency_type') === 'once') {
            if (!/\d{4}\-\d{2}\-\d{2}\s\d{2}:\d{2}/.test(formData.get('when'))) {
                errors.when = __('scheduled_transactions.errors_when');
            } else {
                const selected = new Date(formData.get('when'));
                const now = new Date();

                if (selected < now) {
                    errors.when = __('scheduled_transactions.error_when_cannot_be_in_the_past');
                }
            }
        }

        if (formData.get('frequency_type') === 'weekly') {
            let day = Number(formData.get('due_day'));
            if (day <= 0 || day > 7) {
                errors.due_day = __('scheduled_transactions.error_choose_day');
            }
        }

        if (formData.get('frequency_type') === 'monthly') {
            if (formData.get('end_of_month') === null) {
                let day = Number(formData.get('due_day'));
                if (day <= 0 || day > 31) {
                    errors.due_day = __('scheduled_transactions.error_choose_day');
                }
            }
        }

        if (formData.get('frequency_type') === 'yearly') {
            let day = Number(formData.get('frequency_interval'));
            if (day <= 0 || day > 12) {
                errors.frequency_interval = __('scheduled_transactions.error_choose_month');
            }

            if (formData.get('end_of_month') === null) {
                let day = Number(formData.get('due_day'));
                if (day <= 0 || day > 31) {
                    errors.due_day = __('scheduled_transactions.error_choose_day');
                }
            }
        }

        if (!['expense', 'income'].includes(formData.get('type'))) {
            errors.type = __('error_choose_transaction_type');
        }

        if (!/^[0-9]+$/.test(formData.get('category'))) {
            errors.category = __('error_choose_category');
        }

        if (!/^(?:[1-9]\d*([\.,]\d+)?|0[\.,]\d*[1-9]\d*)$/.test(formData.get('amount'))) {
            errors.amount = __('error_specify_amount');
        }

        if (!Object.keys(errors).length) {
            formData = Object.fromEntries(formData);
            form.querySelector('.button--success').classList.add('button--disabled');

            this.data.scheduledTransactionUpdate(id, formData).then((response) => {
                if (response.status === 'success' && !response.error) {
                    showSnackbar(__('text_saved_successful'), 'success', '/' + SYSTEM_LANGUAGE + '/scheduled-transactions');
                    formsSync();
                } else {
                    renderBEerrors(form, response.data);
                }
            });
        } else {
            renderFEerrors(form, errors);
        }
    }

    toggleTransactionStatus(target) {
        const element = target.closest('[data-id]');
        const checkedState = target.checked;

        this.data.transactionToggleStatus(element.dataset.id, target.checked).then((response) => {
            if (response.status === 'success' && !response.error) {

                if (target.checked) {
                    toggleInactiveElements(element.dataset.id, true);
                } else {
                    toggleInactiveElements(element.dataset.id, false);
                }

                showSnackbar(__('text_saved_successful'), 'success');
            } else {
                target.checked = !checkedState;
            }
        });
    }

    toggleScheduledTransactionActive(target) {
        const element = target.closest('[data-id]');
        const checkedState = target.checked;

        this.data.scheduledTransactionToggleActive(element.dataset.id, target.checked).then((response) => {
            if (response.status === 'success' && !response.error) {

                if (target.checked) {
                    toggleInactiveElements(element.dataset.id, true);
                    if (response.data.next_run_at) {
                        const formattedDate = dateFormat(response.data.next_run_at);
                        element.querySelector('.grid__cell--next-run-at').innerHTML = '<span class="text" data-tooltip="' + formattedDate + '">' + formattedDate + '</span>';
                    }
                } else {
                    toggleInactiveElements(element.dataset.id, false);
                    element.querySelector('.grid__cell--next-run-at').innerHTML = '<span class="grid__cell--empty">-</span>';
                }

                const status = element.querySelector('.grid__cell--status');
                status.classList.remove('status-scheduled', 'status-running', 'status-paused', 'status-completed');
                status.classList.add('status-' + response.data.status);
                status.querySelector('span').textContent = __('label_' + response.data.status.toLowerCase());

                showSnackbar(__('text_saved_successful'), 'success');
            } else {
                target.checked = !checkedState;
            }
        });
    }

    toggleScheduledTransactionAutoApprove(target) {
        const element = target.closest('[data-id]');

        this.data.scheduledTransactionToggleAutoApprove(element.dataset.id, target.checked).then((response) => {
            if (response.status === 'success' && !response.error) {
                showSnackbar(__('text_saved_successful'), 'success');
            }
        });
    }
}